// import React from "react";
// import ReactDOM from "react-dom";
// import  "assets/css/App.css";
// import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
// import AuthLayout from "layouts/auth";
// import AdminLayout from "layouts/admin";

// import { ChakraProvider } from "@chakra-ui/react";
// import theme from "theme/theme";
// import { AuthProvider } from "./auth-context/auth.context";
// import { ProtectedRoute } from "./layouts/protected.route.js";

// let user = localStorage.getItem("user");
// user = JSON.parse(user);
// ReactDOM.render(
//   <ChakraProvider theme={theme}>
//     <AuthProvider userData={user}>
//     <React.StrictMode>
//       <HashRouter>
//         <Switch>
//           <Redirect exact from="/" to="/auth" />
//           <Route path={`/auth`} component={AuthLayout} />
//           <ProtectedRoute path={`/admin`} component={AdminLayout} />
//         </Switch>
//       </HashRouter>
//     </React.StrictMode>
//     </AuthProvider>
//   </ChakraProvider>,
//   document.getElementById("root")
// );

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "assets/css/App.css";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme";
import { AuthProvider } from "./auth-context/auth.context";
import { ProtectedRoute } from "./layouts/protected.route.js";

// let user = localStorage.getItem("user");
// user = JSON.parse(user);

// ✅ Safe user parsing
let user = null;
try {
  const stored = localStorage.getItem("user");
  if (stored) user = JSON.parse(stored);
} catch (e) {
  console.warn("⚠️ Invalid user data, clearing storage");
  localStorage.clear();
}

// ✅ Clear storage when tab/browser closes
// const clearStorage = () => {
//   localStorage.clear();
//   sessionStorage.clear();
// };
// window.addEventListener("beforeunload", clearStorage);
// window.addEventListener("pagehide", clearStorage);
 
ReactDOM.render(
  <ChakraProvider theme={theme}>
    <AuthProvider userData={user}>
      <Suspense fallback={<div style={{ color: "white", padding: "20px" }}>Loading...</div>}>
        <HashRouter>
          <Switch>
            <Redirect exact from="/" to="/auth" />
            <Route path={`/auth`} component={AuthLayout} />
            <ProtectedRoute path={`/admin`} component={AdminLayout} />
          </Switch>
        </HashRouter>
      </Suspense>
    </AuthProvider>
  </ChakraProvider>,
  document.getElementById("root")
);
